module.exports = __webpack_public_path__ + "media/images/front/icon_like_off-15d7b4be3bcac4638c5774b3918abeea.png";